import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Container from 'react-bootstrap/Container';
import classes from './Navigation.module.css';
import {useState, useEffect} from 'react';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import SearchIcon from '@mui/icons-material/Search';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import '../../animations.css';
import {PRODUCTS} from '../../URLS';
import {Link} from 'react-router-dom';

const Navigation = ({dropdowns, links, containerClass="", navigationClass="", dropdownHeaderClass=""}) => {
  
  const icons = ['instagram', 'facebook', 'whatsapp'];
  const [mobileNav, setMobileNav] = useState(false);
  const [mobileNavItems, setMobileNavItems] = useState({});
  const [animateIcon, setAnimateIcon] = useState(false);

  const interactMobileNav = (display) => {
    if (mobileNav !== display) {
      setMobileNav(display);
    }
  }

  const interactSingleNav = (display, item) => {
    if (mobileNavItems[item] !== display) {
      let change = {...mobileNavItems};
        change = Object.entries(change).reduce((curr, [k, v]) => {
          return {
            ...curr, 
            [k]: false
          }
        }, {});
        change[item] = display;
        setMobileNavItems(change);
    }
  } 

  useEffect(() => {
    if (!Object.keys(mobileNavItems).length) {
      setMobileNavItems(dropdowns.reduce((curr, [title]) => {
        return {
          ...curr,
          [title]: false
        }
      }, {}));
    }

    if (mobileNav && !animateIcon) {
      setTimeout(() => {
        setAnimateIcon(true);
      }, 1000);
    }

    if (!mobileNav && animateIcon) {
      setAnimateIcon(false);
    }
    
  }, [dropdowns, mobileNav])

	return (
		<div className={`${classes.navigation} ${containerClass}`}>
        <Navbar bg="light" expand={false}
                onToggle={(expanded)=>{interactMobileNav(expanded)}}>
          <Container>
            <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={()=>{interactMobileNav(true)}}/>
          </Container>
        </Navbar>
        <SwipeableDrawer anchor={"top"} 
                         open={mobileNav} 
                         onOpen={()=>{interactMobileNav(true)}}
                         onClose={()=>{interactMobileNav(false)}}>
          <div className={classes.mobileNav}>
            <span className={`${animateIcon ? 'open-icon-middle' : ''}`} style={{
              marginLeft: `${animateIcon ? '0px' : ''}`
            }} onClick={() => {
              interactMobileNav(false)
            }}/>
            <div className={classes.mobileNavSearchGrid}>
              <div className={classes.mobileNavSearchContainer}>
                <input placeholder={"Buscar"}/>
                <SearchIcon/>
              </div>
            </div>
            <ul className={classes.mobileNavProductContainer}>
              {
                Object.keys(mobileNavItems).map((product, index) => 
                  <div className={`${classes.mobileNavProductContainerItem} ${mobileNavItems[product] ? 'showDrop' : 'hideDrop'}`} key={index+3}>
                    <div>
                      <p>{product}</p>
                      <ExpandMoreIcon onClick={()=>{
                          if (mobileNavItems[product]) {
                              interactSingleNav(false, product)
                          } else {
                              interactSingleNav(true, product)
                          }
                            }} sx={{
                              transition: 'all 0.4s ease-out',
                              transform: mobileNavItems[product] ? 'rotateZ(180deg)' : ''
                            }}/>
                    </div>
                    <ul 
                    className={`${!mobileNavItems[product] ? 'hideMobileDrop' : 'showMobileDrop'}`}>
                      <Link className={"dropdownLink"} to={PRODUCTS[product]} key={index+500}>Todos</Link>
                      {
                        dropdowns.reduce((curr, [item, list]) => {
                            return {
                              ...curr,
                              [item]:list
                            }
                        }, {})[product].map((item,itemIndex) => 
                        <Link to={PRODUCTS[item]} key={itemIndex} className={"dropdownLink"}>{item}</Link>)
                      }
                    </ul>
                  </div>
                  )
              }
            </ul>
            <div className={classes.mobileNavIconContainer}>
              {
                icons.map((icon, index) => {
                  const styles = {
                    fontSize: '30px',
                    color: '#545454'
                  }
                  switch (icon) {
                    case 'whatsapp':
                      return <WhatsAppIcon key={index} sx={styles}/>
                      break;
                    case 'instagram':
                      return <InstagramIcon key={index} sx={styles}/>
                      break;
                    case 'facebook':
                      return <FacebookIcon key={index} sx={styles}/>
                      break;
                    default:
                      return null
                  } 
                })
              }
            </div>
          </div>
        </SwipeableDrawer>
    </div>
	);
};

export default Navigation;